import { atom } from "jotai";

import type { SessionStatus, SessionUser } from "./types";

export const sessionUserAtom = atom<SessionUser | null>(null);
export const sessionStatusAtom = atom<SessionStatus>("loading");

/** Derived: true once status resolved (authenticated or unauthenticated). */
export const sessionResolvedAtom = atom((get) => get(sessionStatusAtom) !== "loading");

/** Derived: role check helper. Empty roles array = any authenticated user. */
export const hasRoleAtom = (roles: SessionUser["role"][]) =>
  atom((get) => {
    const user = get(sessionUserAtom);
    if (!user) return false;
    if (roles.length === 0) return true;
    return roles.includes(user.role);
  });
